"use client"

import type React from "react"

import { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

interface ResourceTabsProps {
  children: React.ReactNode
}

export function ResourceTabs({ children }: ResourceTabsProps) {
  const [activeTab, setActiveTab] = useState("resources")

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-2 mb-8 text-gray-800">
        <TabsTrigger value="resources">Resources</TabsTrigger>
        <TabsTrigger value="assessments">Assessments</TabsTrigger>
      </TabsList>
      <TabsContent value="resources" className="space-y-6">
        {children}
      </TabsContent>
      <TabsContent value="assessments" className="space-y-6">
        <div className="text-center py-12">
          <p className="text-muted-foreground text-gray-800">Assessments coming soon</p>
        </div>
      </TabsContent>
    </Tabs>
  )
}
